import React, { useEffect, useState } from "react";
import { Table, Button, Tooltip, Input } from "antd";
import { SyncOutlined, SearchOutlined } from "@ant-design/icons";

const SimplestTable = ({
  data,
  columns,
  width,
  tableName,
  pageSize,
  loading,
  onRefresh,
}) => {
  const [innerPageSize, setInnerPageSize] = useState(pageSize || 10);

  // Sync with prop changes
  useEffect(() => {
    if (pageSize && pageSize !== innerPageSize) {
      setInnerPageSize(pageSize);
    }
  }, [pageSize]);

  return (
    <div className={width}>
      <div
        className="box"
        style={{ border: "1px solid #f0f0f0", borderRadius: 8 }}
      >
        <div
          className="box-header"
          style={{
            padding: 16,
            borderBottom: "1px solid #f0f0f0",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h3 style={{ margin: 0 }}>{tableName}</h3>
          <div>
            {/* <Tooltip title="Refresh">
              <Button
                icon={<SyncOutlined />}
                onClick={onRefresh}
                style={{ marginRight: 8 }}
              />
            </Tooltip> */}
            {/* <Input.Search
              placeholder="Search..."
              onSearch={(value) => console.log(value)} // Implement your search logic
              enterButton={<SearchOutlined />}
              style={{ width: 200 }}
            /> */}
          </div>
        </div>
        <div className="box-body" style={{ padding: 16 }}>
          <Table
            rowKey="id"
            columns={columns}
            dataSource={data}
            loading={loading}
            pagination={{
              pageSize: innerPageSize,
              showSizeChanger: true,
              pageSizeOptions: ["5", "10", "20", "50", "100"],
              onChange: (page, size) => setInnerPageSize(size),
              onShowSizeChange: (current, size) => setInnerPageSize(size),
              showTotal: (total) => `Total ${total} items`,
            }}
            scroll={{ x: true }}
            bordered
            size="middle"
          />
        </div>
      </div>
    </div>
  );
};

export default SimplestTable;
